import React from 'react';
import { Button } from '@components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle
} from '@components/ui/dialog';

interface RemoveEntryDialogProps {
    name?: string;
    loading?: boolean;
    onClose(): void;
    onConfirm(): Promise<void>;
}

export function RemoveEntryDialog({
    name,
    loading,
    onClose,
    onConfirm
}: RemoveEntryDialogProps) {
    return (
        <Dialog
            open={Boolean(name)}
            onOpenChange={(next) => !next && onClose()}
        >
            <DialogContent className="sm:max-w-xs">
                <DialogHeader>
                    <DialogTitle>Remove from leaderboard</DialogTitle>
                    <DialogDescription>
                        {`${name} will be removed from this challenge's leaderboard
                        and the remaining positions will be recalculated. Their
                        result is not recoverable from the admin portal.`}
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <Button
                        variant="ghost"
                        onClick={onClose}
                        disabled={loading}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="destructive"
                        loading={loading}
                        onClick={() => void onConfirm()}
                    >
                        Remove
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
